module.exports = __webpack_public_path__ + "static/media/README.2a2479f0.md";